<template>
    <div
        class="loading d-flex justify-content-center align-items-center"
        :class="[...classes, { loading__fullscreen: fullscreen }]"
        :style="{ ...customStyle }"
    >
        <div class="loading__thumbnail d-inline-block">
            <picture class="loading__thumbnail__image d-inline-block">
                <source
                    :srcset="require('@/assets/images/loading.webp')"
                    type="image/webp"
                />
                <img
                    :src="require('@/assets/images/loading.gif')"
                    alt="Loading..."
                />
            </picture>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customStyle: Object,
        default() {
            return {
                width: '100%',
                height: '100%',
            };
        },
        classes: {
            type: Array,
            default() {
                return [];
            },
        },
        fullscreen: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
@import './Spinner';
</style>
